import React, { Component } from 'react';
import { ListBlogComponent } from '../layouts/blog';
import { HeaderModern, TopBar, TopHeader, Footer, Loader } from '../layouts/general';

class Blog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            headers: [{ id: 1, names: 'Resources' }]
        };
    }

    render() {
        return (
            <div className="bg-body3">
                <div className="boxed">
                    <Loader />
                    <TopBar />
                    <TopHeader />
                    {this.state.headers.map((data) => (
                        <HeaderModern data={data} key={data.id} />
                    ))}

                    <ListBlogComponent showTitle />

                    <Footer />
                </div>
            </div>
        );
    }
}

export default Blog;
